import React, { useEffect, useRef, useState } from "react";
import {
    ArrowLeft,
    ArrowUpRight,
    ClockCounterClockwise,
    Funnel,
    Star,
    X,
} from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import PageLoader from "../loader/PageLoader";
import ConfirmPrice from "./ConfirmPrice";
import PastRequests from "./PastRequests";
import WebCheckin from "./WebCheckin";
import EarlyCheckin from "./EarlyCheckin";
import LateCheckout from "./LateCheckout";
import Dining from "./Dining";
import { useQuery } from "@tanstack/react-query";
import HouseKeeping from "./HouseKeeping";
import WakeUp from "./WakeUp";
import ConferenceRoom from "./ConferenceRoom";
import ExtendStay from "./ExtendStay";
import Custom from "./Custom";
import RestaurantTable from "./RestaurantTable";
import RoomChange from "./RoomChange";
import Checkout from "./Checkout";
import Wifi from "./Wifi";
import Spa from "./Spa";
import NotificationProvider from '../NotificationProvider';
import RestaurantDining from "./RestaurantDining";
 
const Request = () => {
    const [openFilter, setOpenFilter] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [cabToHotel, setCabToHotel] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(false);
    const [activeComponent, setActiveComponent] = useState(null);
    const [filters, setFilters] = useState({
        roomNumber: "",
        preCheckin: false,
        postCheckin: false,
        staff: "",
        requests : [],
    });
    const hotelId = localStorage.getItem("hotelId");
    const [openPastReq, setOpenPastReq] = useState(false);

    // For Filters
    const requestOptions = [
        "PreCheckin Cab Request",
        "PreCheckin Early Checkin Request",
        "Web Checkin",
        "PostCheckin ExtendStay Request",
        "PostCheckin Late Checkout Request",
        "PostCheckin Room Change Request",
        "Custom Request",
        "Get Wifi",
        "Wake Up Call",
        "Restaurant Table",
        "Spa",
        "PostCheckin Cab Request",
        "HouseKeeping",
        "In Room Dining",
        "Checkout",
        "Conference Room",
        "Restaurant Dining"
    ];


    // For Services
    const serviceMap = {
        HouseKeeping: "Post-Checkin",
        "In Room Dining": "Post-Checkin",
        "PreCheckin Cab Request": "Pre-Checkin",
        "PostCheckin Cab Request": "Post-Checkin",
        Checkout: "Post-Checkin",
        "Conference Room": "Post-Checkin",
        "Custom Request": "Post-Checkin",
        "PreCheckin Early Checkin Request": "Pre-Checkin",
        "PostCheckin ExtendStay Request": "Post-Checkin",
        "PostCheckin Late Checkout Request": "Post-Checkin",
        "Restaurant Table": "Post-Checkin",
        "PostCheckin Room Change Request": "Post-Checkin",
        Spa: "Post-Checkin",
        "Wake Up Call": "Post-Checkin",
        "Web Checkin": "Pre-Checkin",
        "Get Wifi": "Post-Checkin",
    };

    // console.log(".......", serviceMap.HouseKeeping);

    const fetchActiveRequests = async (hotelId) => {
        try{
            const response = await axiosInstance.get(
                `/api/v1/hotels/${hotelId}/active-requests`,
            );
            // console.log(response.data.data[0]?.user_id);
            // localStorage.setItem("userId", response.data.data[0]?.user_id);
            return response.data.data; // Adjust based on your API response structure

        }catch(error){
            if (error.response?.data?.message === "Booked rooms not found") {
                return []; // Return empty array if no bookings
            }
            throw error; // Re-throw other unexpected errors
        }
    };

    // react query for fetching active requests
    const {
        data: fetchData,
        error,
        isLoading,
        isFetching,
        refetch,
    } = useQuery({
        queryKey: ["activeRequests", hotelId],
        queryFn: () => fetchActiveRequests(hotelId),
        refetchOnWindowFocus: true, // This will refetch data when window focus is regained
        staleTime: 5000, // Optional: consider data stale immediately
        refetchInterval: 5000, // Refetch every 5 seconds
    });


//    const previousRequestIdsRef = useRef(new Set());

    // ✅ Load previously stored request IDs on mount
    // useEffect(() => {
    // const storedIds = JSON.parse(localStorage.getItem("previousRequestIds")) || [];
    // previousRequestIdsRef.current = new Set(storedIds);
    // }, []);


    // ✅ Load previously stored request IDs on mount
    // useEffect(() => {
    //     const setPreviousIds = () => {
    //         try{
    //             const storedIds = JSON.parse(localStorage.getItem("previousRequestIds")) || [];
    //             previousRequestIdsRef.current = new Set(storedIds);
    //         }catch(error){
    //             console.log(error)
    //         }
    //     }
    //     setPreviousIds();
    // }, []);

    // function playNotificationSound() {
    //     try {
    //         const audio = new Audio("/notification.wav"); // path from public folder
    //         audio.play().catch((err) => {
    //             console.warn("Autoplay blocked until user interacts:", err);
    //         });
    //     } catch (error) {
    //         console.error("Sound Error:", error);
    //     }
    // }



    // notifications
    // Utility function to send notification
    // function showNotification(title, options = {}) {
    //     try{
    //         if (Notification.permission === "granted") {
    //             new Notification(title, {
    //             body: options.body || "You have a new request!",
    //             icon: options.icon || "/logo.svg",
    //             });
    //         }
    //     }catch(error){
    //         console.log("Notification Error : ",error);
    //     }
    // }

    
    useEffect(() => {
        // Ask permission once on mount
        function requestNotificationPermission() {
            try{
                if ("Notification" in window && Notification.permission !== "granted") {
                    Notification.requestPermission();
                }
            }catch(error){
                console.log("Notification Permission Error : ",error);
            }
        }
        requestNotificationPermission();
    }, []);






    // useEffect(() => {
    //     const notificationsFunction = () => {
    //         try {
    //         if (!Array.isArray(fetchData)) return;

    //         const newRequestIds = new Set(fetchData.map((req) => req.id));
    //         const previousIds = previousRequestIdsRef.current;

    //         // Find newly added requests
    //         const newRequests = fetchData.filter((req) => !previousIds.has(req.id));

    //         if (newRequests.length > 0) {
    //             playNotificationSound();
    //             newRequests.forEach((request) => {
    //                 showNotification("New Check-in Request", {
    //                     body: `${request?.type || ""}`,
    //                     icon: "/logo.svg",
    //                 });
    //             });
    //         }

    //         // ✅ Update memory and localStorage
    //         previousRequestIdsRef.current = newRequestIds;
    //         localStorage.setItem("previousRequestIds", JSON.stringify([...newRequestIds]));

    //         } catch (error) {
    //         console.log("Notification Error:", error);
    //         }
    //     };

    //     notificationsFunction();
    // }, [fetchData]);


 



    const data = fetchData;

    // For Setting Up The Data
    useEffect(() => {
        if (data) {
            // Apply initial filtering or transformation to data
            setFilteredData(data); // You can modify this to apply a default filter if needed
        }
    }, [data]);

    // For Applying Filter
    const applyFilter = () => {
        try{
            let filtered = data || [];
       

            //  4-things
            // Filter by Room Number, Both Pre/Post CheckIn, and Staff 4 things
            if (
                filters.roomNumber &&
                (filters.preCheckin || filters.postCheckin) &&
                filters.staff
            ) {
                // console.log("Room Number, Both Status, and Staff Name");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    const roomNumber = d.room_number || "";
                    const staffName = d.staff_member_name || "";

                    if (
                        (serviceType === "Pre-Checkin" ||
                            serviceType === "Post-Checkin") &&
                        filters.roomNumber === roomNumber.toString() &&
                        filters.staff === staffName
                    ) {
                        // console.log("Filtered by Room, Status, and Staff");
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }
       

            //  filter by room number,staff,requests,precheck 4 things
            // if(filters.roomNumber && filters.staff && filters.requests.length>0 && filters.preCheckin){
            //     filtered = filtered.filter((d)=>{
            //         const roomNumber = d.room_number || "";
            //         const serviceType = serviceMap[d.type];  
            //         const staffName = d.staff_member_name || "";
            //         if(filters.roomNumber === roomNumber.toString() && filters.requests.includes(d.type) && serviceType === "Pre-Checkin" && filters.staff===staffName){
            //             return true;
            //         }
            //         else{
            //             return false;
            //         }
            //     })
            //     console.log("Filtered Data : ",filtered)
            //     setFilteredData(filtered);
            //     setOpenFilter(false);
            //     return;
            // }


            // //  filter by room number,staff,requests,postcheck 4 things
            // if(filters.roomNumber && filters.staff && filters.requests.length>0 && filters.postCheckin){

            //     filtered = filtered.filter((d)=>{
            //         const roomNumber = d.room_number || "";
            //         const serviceType = serviceMap[d.type];  
            //         const staffName = d.staff_member_name || "";
            //         if(filters.roomNumber === roomNumber.toString() && filters.requests.includes(d.type) && serviceType === "Post-Checkin" && filters.staff===staffName){
            //             return true;
            //         }
            //         else{
            //             return false;
            //         }
            //     })
            //     // console.log("Filtered Data : ",filtered)
            //     setFilteredData(filtered);
            //     setOpenFilter(false);
            //     return;
            // }

            // 3 things
            // Filter by requests,room number,postcheckin status 3 things
            if(filters.requests.length>0 && filters.postCheckin && filters.roomNumber){

                filtered = filtered.filter((d)=>{
                    const roomNumber = d.room_number || "";
                     const serviceType = serviceMap[d.type];  
                    if(filters.roomNumber === roomNumber.toString() && filters.requests.includes(d.type) && serviceType === "Post-Checkin"){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }


            // Filter by requests,room number,precheckin status 3 things
            if(filters.requests.length>0 && filters.preCheckin && filters.roomNumber){

                filtered = filtered.filter((d)=>{
                    const roomNumber = d.room_number || "";
                     const serviceType = serviceMap[d.type];  
                    if(filters.roomNumber === roomNumber.toString() && filters.requests.includes(d.type) && serviceType === "Pre-Checkin"){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by requests,staff,precheckin status 3 things
            if(filters.requests.length>0 && filters.preCheckin && filters.staff){

                filtered = filtered.filter((d)=>{
                    const staffName = d.staff_member_name || "";
                     const serviceType = serviceMap[d.type];  
                    if(filters.staff===staffName && filters.requests.includes(d.type) && serviceType === "Pre-Checkin"){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by requests,staff,postcheckin status 3 things
            if(filters.requests.length>0 && filters.postCheckin && filters.staff){

                filtered = filtered.filter((d)=>{
                    const staffName = d.staff_member_name || "";
                     const serviceType = serviceMap[d.type];  
                    if(filters.staff===staffName && filters.requests.includes(d.type) &&  serviceType === "Post-Checkin" ){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by requests,room-number,staff 3 things
            if(filters.requests.length>0 && filters.roomNumber && filters.staff){

                filtered = filtered.filter((d)=>{
                    const staffName = d.staff_member_name || "";
                    const roomNumber = d.room_number || "";
                    if(filters.staff===staffName && filters.requests.includes(d.type) && filters.roomNumber === roomNumber.toString()){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by Room Number and Both Pre/Post CheckIn 3 things
            if (filters.roomNumber && filters.preCheckin && filters.postCheckin) {
                // console.log("Room Number and Both Status (Pre/Post Checkin)");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    const roomNumber = d.room_number || "";

                    if (
                        (serviceType === "Pre-Checkin" ||
                            serviceType === "Post-Checkin") &&
                        filters.roomNumber === roomNumber.toString()
                    ) {
                        // console.log("Room Number and Both Status");
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Kushal For Staff Name and Both Status 3 things
            if (filters.preCheckin && filters.postCheckin && filters.staff) {
                // console.log("Here In Both Status");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    const staffName = d.staff_member_name;

                    if (
                        (serviceType === "Post-Checkin" ||
                            serviceType === "Pre-Checkin") &&
                        filters.staff === staffName
                    ) {
                        // console.log("Here 2 Status and Staff");
                        return true;
                    } else {
                        return false;
                    }
                });

                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Kushal-- Filter For Both Post CheckIn and PreCheckIn 2 things
            if (filters.preCheckin && filters.postCheckin) {
                // console.log("Here In Both Status");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type

                    if (
                        serviceType === "Post-Checkin" ||
                        serviceType === "Pre-Checkin"
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By requests and room number  2 things
            if (filters.roomNumber && filters.requests.length > 0) {
                filtered = filtered.filter((d) =>{
                    const roomNumber = d.room_number || "";
                    if(roomNumber.toString()===filters.roomNumber && filters.requests.includes(d.type)){
                        return true
                    }   
                    else{
                        return false;
                    }
                });
                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Requests and staff  2 things
            if (filters.staff && filters.requests.length > 0) {

                filtered = filtered.filter((d)=>{
                    const staffName = d.staff_member_name || "";
                    if(filters.staff===staffName && filters.requests.includes(d.type)){
                        return true;
                    }
                    else{
                        return false;
                    }
                })
                // console.log("Filtered Data : ",filtered)
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By requests and precheckin 2 things
            if(filters.requests.length>0 && filters.preCheckin){
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    if(filters.requests.includes(d.type) && serviceType === "Pre-Checkin"){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                setFilteredData(filtered);
                setOpenFilter(false);
                return;

            }

            // By requests and postcheckin 2 things
            if(filters.requests.length>0 && filters.postCheckin){
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    if(filters.requests.includes(d.type) && serviceType === "Post-Checkin"){
                        return true;
                    }
                    else{
                        return false;
                    }
                })

                setFilteredData(filtered);
                setOpenFilter(false);
                return;

            }



            // Filter by Room Number and Pre CheckIn  2 things
            if (filters.roomNumber && filters.preCheckin) {
                // console.log("Room Number and Pre Checkin");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    const roomNumber = d.room_number || "";

                    if (
                        serviceType === "Pre-Checkin" &&
                        filters.roomNumber === roomNumber.toString()
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by Room Number and Post CheckIn  2 things
            if (filters.roomNumber && filters.postCheckin) {
                // console.log("Room Number and Post Checkin");
                filtered = filtered.filter((d) => {
                    const serviceType = serviceMap[d.type]; // Get the service type
                    const roomNumber = d.room_number || "";

                    if (
                        serviceType === "Post-Checkin" &&
                        filters.roomNumber === roomNumber.toString()
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Kushal --- If There is Post Check In and Staff Both  2 things
            if (filters.postCheckin && filters.staff) {
                filtered = filtered.filter((d) => {
                    const staffName = d.staff_member_name || "";
                    if (
                        filters.staff === staffName &&
                        serviceMap[d.type] === "Post-Checkin"
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Kushal --- If There is Pre Check In and Staff Both  2 things
            if (filters.preCheckin && filters.staff) {
                filtered = filtered.filter((d) => {
                    const staffName = d.staff_member_name || "";
                    if (
                        filters.staff === staffName &&
                        serviceMap[d.type] === "Post-Checkin"
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // By Kushal --- Filter Added For roomnumber and staff  2 things
            if (filters.roomNumber && filters.staff) {
                // console.log("Room Number and Staff Name");
                filtered = filtered.filter((d) => {
                    const roomNumber = d.room_number || "";
                    const staffName = d.staff_member_name || "";
                    if (
                        filters.staff === staffName &&
                        filters.roomNumber === roomNumber.toString()
                    ) {
                        // console.log("Here in Room and Staff");
                        return true;
                    } else {
                        return false;
                    }
                });
                // console.log("Filtered Data : " + filteredData);
                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }

            // Filter by room number
            if (filters.roomNumber) {
                filtered = filtered.filter((d) => {
                    const roomNumber = d.room_number || "";
                    return roomNumber.toString().includes(filters.roomNumber);
                });
            }
            // Filter by status
            if (filters.preCheckin) {
                filtered = filtered.filter(
                    (d) => serviceMap[d.type] === "Pre-Checkin",
                );
            }
            // Filter by status
            if (filters.postCheckin) {
                filtered = filtered.filter(
                    (d) => serviceMap[d.type] === "Post-Checkin",
                );
            }

            // Filter By Staff
            if (filters.staff) {
                filtered = filtered.filter((d) => {
                    return d.staff_member_name === filters.staff;
                });
            }

            // Filter Data By Requests 
            if (filters.requests.length > 0) {
                filtered = filtered.filter((d) => 
                    filters.requests.includes(d.type)
                );

                setFilteredData(filtered);
                setOpenFilter(false);
                return;
            }


            setFilteredData(filtered);
            setOpenFilter(false);

        }catch(error){
            console.log(error);
        }
  
    };

    // For Status
    const statusOrder = [
        "Pending_Guest",
        "Pending_Hotel",
        "InProgress_Hotel",
        "Scheduled_Hotel",
    ];

    // Reset
    const resetFilters = () => {
        setFilters({
            roomNumber: "",
            preCheckin: false,
            postCheckin: false,
            staff: "",
            requests : []
        });
        setFilteredData(data || []); // Reset to original data
        setOpenFilter(false);
    };

    // For Filter Change
    const handleFilterChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const toggleRequest = (request) => {
        setFilters((prev) => {
            const alreadySelected = prev.requests.includes(request);
            const updatedRequests = alreadySelected
                ? prev.requests.filter((r) => r !== request)
                : [...prev.requests, request];

            return { ...prev, requests: updatedRequests };
        });
    };

    // Status Color and Data
    const getStatusDetails = (status) => {
        const statusMap = {
            Pending_Guest: {
                title: "Pending On Guest",
                bgColor: "bg-[#FFF4D9]",
                headerBg: "bg-[#FFE29B]",
                statusBg: "bg-[#A88737]",
            },
            Pending_Hotel: {
                title: "Pending On You",
                bgColor: "bg-[#FFF2F2]",
                headerBg: "bg-[#FFBFC1]",
                statusBg: "bg-[#FF5A5F]",
            },
            InProgress_Hotel: {
                title: "Ongoing",
                bgColor: "bg-[#EEF0FB]",
                headerBg: "bg-[#939EDE]",
                statusBg: "bg-[#0B22B2]",
            },
            Scheduled_Hotel: {
                title: "Scheduled",
                bgColor: "bg-[#EDFFFA]",
                headerBg: "bg-[#D9F8F2]",
                statusBg: "bg-[#6DABA1]",
            },
        };
        return statusMap[status] || statusMap["Ongoing"];
    };

    // const groupedRequests = filteredData.reduce((acc, request) => {
    //     const currentTime = new Date(); // Get current time
    //     const requestedTime = new Date(request.requested_time);
    //     const status = request.status.includes("Pending_Guest")
    //         ? "Pending_Guest"
    //         : request.status.includes("Pending_Hotel")
    //         ? "Pending_Hotel"
    //         : request.status.includes("InProgress_Hotel") &&
    //           request.staff_status === "" &&
    //           currentTime < requestedTime
    //         ? "Scheduled"
    //         : "InProgress_Hotel";
    //     if (!acc[status]) acc[status] = [];
    //     acc[status].push(request);
    //     return acc;
    // }, {});

    // THis Is For Filtering Request According to the Status
    const groupedRequests = filteredData?.reduce((acc, request) => {
        const status = request.status.includes("Pending_Guest")
            ? "Pending_Guest"
            : request.status.includes("Pending_Hotel")
            ? "Pending_Hotel"
            : request.status.includes("InProgress_Hotel")
            ? "InProgress_Hotel"
            : "Scheduled_Hotel";
        if (!acc[status]) acc[status] = [];
        acc[status].push(request);
        return acc;
    }, {});

    const escalationRank = { l1: 1, l2: 2, stuck: 3 };

    const getEscalationDetails = (request) => {
        const level = request?.escalation_level;
        if (!level || !escalationRank[level]) return null;

        if (level === "stuck") {
            return {
                label: "Overdue — still not closed",
                timePrefix: "in progress",
                cardClasses:
                    "ring-2 ring-[#FF5A5F] escalation-pulse-strong",
                chipClasses: "bg-[#0B22B2] text-white",
            };
        }

        if (level === "l2") {
            return {
                label: "Escalated to manager",
                timePrefix: "waiting",
                cardClasses:
                    "ring-2 ring-[#FF5A5F] escalation-pulse-strong",
                chipClasses: "bg-[#FF5A5F] text-white",
            };
        }

        return {
            label: "Needs action now",
            timePrefix: "waiting",
            cardClasses: "ring-2 ring-[#FFBFC1] escalation-pulse-soft",
            chipClasses: "bg-[#B74044] text-white",
        };
    };

    const getWaitingSince = (request) =>
        request?.status_changed_at || request?.created_at || request?.updated_at;

    // For Getting The time
    const getRelativeTime = (timestamp) => {
        const now = new Date();
        const updated = new Date(timestamp);
        const diffInSeconds = Math.floor((now - updated) / 1000);

        if (diffInSeconds < 60) return `${diffInSeconds}sec ago`;
        if (diffInSeconds < 3600)
            return `${Math.floor(diffInSeconds / 60)}min ago`;
        if (diffInSeconds < 86400)
            return `${Math.floor(diffInSeconds / 3600)}hr ago`;
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} ${days > 1 ? "days ago" : "day ago"}`;
    };

    // For Getting Each Request Card
    const RequestCard = ({ request }) => {
        const escalation = getEscalationDetails(request);

        return (
        <div
            className={`bg-white rounded-md p-2 mb-2 ${
                escalation ? escalation.cardClasses : ""
            }`}
        >
            {escalation && (
                <div
                    className={`${escalation.chipClasses} mb-2 flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] font-semibold`}
                >
                    <span className="h-1.5 w-1.5 rounded-full bg-white"></span>
                    {escalation.label} · {escalation.timePrefix}{" "}
                    {getRelativeTime(getWaitingSince(request)).replace(
                        " ago",
                        "",
                    )}
                </div>
            )}
            <div className="flex items-center justify-between border-b-[1.5px] pb-2">
                <h2 className="text-[#262B33]">
                    <span
                        className={`${
                            request.status === "Ongoing"
                                ? "text-[#0C196C]"
                                : "text-[#B74044]"
                        } mr-2 font-semibold`}
                    >
                        {request.type === "PostCheckin Room Change Request"
                            ? "Room Change Request"
                            : request.type}
                    </span>
                    {/* {request.type.split(" ").slice(0).join(" ")} */}
                </h2>
                <div className="relative inline-block">
                    <button
                        className="hover:bg-[#F2F7FF] border-[1.5px] rounded-md p-1.5 z-0"
                        value={request.type}
                        onClick={() => {
                            // Set the selected cab request
                            setSelectedRequest({
                                type: request.type,
                                hotelId: request.hotel_id,
                                bookingId: request.booking_id,
                                bookedRoomId: request.booked_room_id,
                                requestId: request.id,
                                roomNumber: request.room_number,
                                userId: request.user_id,
                                status: request.status,
                            });
                            setCabToHotel(true);
                            if (
                                request.type === "PreCheckin Cab Request" ||
                                request.type === "PostCheckin Cab Request"
                            ) {
                                setActiveComponent("ConfirmPrice");
                            } else if (request.type === "Web Checkin") {
                                setActiveComponent("WebCheckin");
                            } else if (
                                request.type ===
                                "PreCheckin Early Checkin Request"
                            ) {
                                setActiveComponent(
                                    "PreCheckin Early Checkin Request",
                                );
                            } else if (
                                request.type ===
                                "PostCheckin Late Checkout Request"
                            ) {
                                setActiveComponent(
                                    "PostCheckin Late Checkout Request",
                                );
                            } else if (request.type === "In Room Dining") {
                                setActiveComponent("Dining");
                            } 
                            else if (request.type === "Restaurant Dining") {
                                setActiveComponent("Restaurant Dining");
                            }
                            else if (request.type === "HouseKeeping") {
                                setActiveComponent("HouseKeeping");
                            } else if (request.type === "Wake Up Call") {
                                setActiveComponent("WakeUp");
                            } else if (request.type === "Conference Room") {
                                setActiveComponent("Conference");
                            } else if (
                                request.type ===
                                "PostCheckin ExtendStay Request"
                            ) {
                                setActiveComponent("extendStay");
                            } else if (request.type === "Custom Request") {
                                setActiveComponent("Custom");
                            } else if (request.type === "Restaurant Table") {
                                setActiveComponent("Restaurant Table");
                            } else if (request.type === "Get Wifi") {
                                setActiveComponent("Get Wifi");
                            } else if (request.type === "Checkout") {
                                setActiveComponent("Checkout");
                            } else if (request.type === "Spa") {
                                setActiveComponent("Spa");
                            } else if (
                                request.type ===
                                "PostCheckin Room Change Request"
                            ) {
                                setActiveComponent(
                                    "PostCheckin Room Change Request",
                                );
                            } else {
                                setActiveComponent("");
                            }

                            // } else if (request.type === "WebCheckin") {
                            //     setActiveComponent("WebCheckin");
                            // }
                        }}
                    >
                        <ArrowUpRight size={19} weight="bold" />
                    </button>
                </div>
            </div>
            {/* {(request.type === "PreCheckin Cab Request" ||
                request.type === "PostCheckin Cab Request") &&
                driverDetails && (
                    <div className="mt-2 text-sm">
                        <p>Driver: {driverDetails.name || "Not assigned"}</p>
                        <p>Contact: {driverDetails.contact || "N/A"}</p>
                    </div>
                )} */}
            <div className={`flex items-center justify-between my-2 `}>
                {request.staff_member_name ? (
                    <button className="bg-[#F2F7FF] px-2 py-1 flex rounded-full items-center gap-1 text-xs">
                        <Star size={15} />
                        {
                        request.staff_status==="StaffDeclined" ? `Rejected By ${request.staff_member_name}`
                            :
                            `Assigned to ${request.staff_member_name}`
                        }
                        
                    </button>
                ) : [
                      "PreCheckin Cab Request",
                      "PostCheckin Cab Request",
                      "PreCheckin Early Checkin Request",
                      "Web Checkin",
                      "Conference Room",
                      "Checkout",
                      "Get Wifi",
                      "PostCheckin ExtendStay Request",
                      "PostCheckin Late Checkout Request",
                      "PostCheckin Room Change Request",
                      "Restaurant Dining",
                  ].includes(request.type) ? (
                    <button></button>
                ) : (
                    <button className="bg-[#F2F7FF] px-2 py-1 flex rounded-full items-center gap-1 text-xs">
                        Staff not assigned
                    </button>
                )}
                {
                    request?.type === "Restaurant Dining" ?
                    (<button></button>):
                    (
                        <button
                            className={`${
                                request.type.split(" ")[0] === "Pre"
                                    ? "bg-[#FAE2E6] text-[#D02746]"
                                    : "bg-[#ECE3FF] text-[#30214E]"
                            } px-2 py-1 flex rounded-full items-center gap-2 text-xs font-semibold`}
                        >
                            <span
                                className={`w-1.5 h-1.5 ${
                                    request.type.split(" ")[0] === "Pre"
                                        ? "bg-[#ff7378]"
                                        : "bg-[#9983C6]"
                                } rounded-full`}
                            ></span>
                            {serviceMap[request.type]}
                        </button>
                    )
                }
            </div>
            <div className="flex items-center justify-between">
                <button className="text-[#737880] text-xs text-nowrap">
                    Request#{" "}
                    <span
                        className="text-[#FF5A5F] font-semibold w-10 overflow-hidden truncate"
                        title={request.id}
                    >
                        {request.id.slice(0, 6) + ".."}
                    </span>
                </button>
                <button className="text-xs">
                    <span className="text-[#737880]">Last updated</span>{" "}
                    {getRelativeTime(request.updated_at)}
                </button>
            </div>
        </div>
        );
    };

    // (async () => {
    //     const grouped = await groupedRequests(filteredData);
    //     setGrouped(grouped);
    //     console.log(grouped);
    // })();

    // if (error) {
    //     console.log("error occured", error)
    // };

    return (
        <div>
            <NotificationProvider />
            {!isFetching && isLoading && <PageLoader />}
            {openPastReq ? (
                <PastRequests
                    closePast={setOpenPastReq}
                    request={selectedRequest}
                />
            ) : (
                <div>
                    <div className="flex justify-between items-center mb-3">
                        <h2 className="text-xl font-semibold tracking-[4px]">
                            REQUESTS
                        </h2>
                        <div className="flex items-center gap-2">
                            <div className="relative inline-block">
                                <button
                                    className="bg-gray-200 px-4 py-2 rounded-lg flex items-center gap-2"
                                    onClick={() => {
                                        setOpenPastReq(true);
                                    }}
                                >
                                    <ClockCounterClockwise size={18} />
                                    Past Requests
                                </button>
                            </div>
                            {cabToHotel && (
                                <>
                                    {activeComponent === "ConfirmPrice" && (
                                        <ConfirmPrice
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "WebCheckin" && (
                                        <WebCheckin
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent ===
                                        "PreCheckin Early Checkin Request" && (
                                        <EarlyCheckin
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent ===
                                        "PostCheckin Late Checkout Request" && (
                                        <LateCheckout
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Dining" && (
                                        <Dining
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "HouseKeeping" && (
                                        <HouseKeeping
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "WakeUp" && (
                                        <WakeUp
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent === "Conference" && (
                                        <ConferenceRoom
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "extendStay" && (
                                        <ExtendStay
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Custom" && (
                                        <Custom
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Restaurant Table" && (
                                        <RestaurantTable
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Get Wifi" && (
                                        <Wifi
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent === "Checkout" && (
                                        <Checkout
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent ===
                                        "PostCheckin Room Change Request" && (
                                        <RoomChange
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Spa" && (
                                        <Spa
                                            func={setCabToHotel}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {
                                        activeComponent === "Restaurant Dining" && (
                                            <RestaurantDining
                                                func={setCabToHotel}
                                                selectedRequest={selectedRequest}
                                            />
                                        )
                                    }
                                </>
                            )}
                            <div className="relative inline-block">
                                <button
                                    className="bg-gray-200 px-4 py-2 rounded-lg flex items-center gap-2"
                                    onClick={() => setOpenFilter(!openFilter)}
                                >
                                    <Funnel size={18} />
                                    Filter
                                </button>

                                {openFilter && (
                                    <div className="absolute top-full right-0 mt-2 border-[1.5px] rounded-md bg-white text-sm w-96 overflow-hidden z-50">
                                        {/* Header of filter modal */}
                                        <div className="flex items-center justify-between bg-[#F2F7FF] px-3 py-2">
                                            <h2 className="font-semibold">
                                                Filters
                                            </h2>
                                            <button
                                                onClick={() =>
                                                    setOpenFilter(false)
                                                }
                                                className="bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                                            >
                                                <X weight="bold" size={15} />
                                            </button>
                                        </div>
                                        
                                        {/* Filter Options */}
                                        <div className="p-3 flex flex-col gap-3">
                                            
                                            {/* Room Numbers */}
                                            <div>
                                                <label
                                                    htmlFor=""
                                                    className="font-medium"
                                                >
                                                    Room Number
                                                </label>
                                                <select
                                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                                        filters.roomNumber ===
                                                        ""
                                                            ? "text-gray-500"
                                                            : "text-black"
                                                    }`}
                                                    name="roomNumber"
                                                    value={filters.roomNumber}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                        className="text-gray-500"
                                                    >
                                                        Choose Room Numbers
                                                    </option>
                                                    {data &&
                                                        data
                                                            .filter(
                                                                (d) =>
                                                                    d.room_number,
                                                            )
                                                            .reduce(
                                                                (unique, d) => {
                                                                    if (
                                                                        !unique.some(
                                                                            (
                                                                                item,
                                                                            ) =>
                                                                                item.room_number ===
                                                                                d.room_number,
                                                                        )
                                                                    ) {
                                                                        unique.push(
                                                                            d,
                                                                        );
                                                                    }
                                                                    return unique;
                                                                },
                                                                [],
                                                            )
                                                            .map((d, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={
                                                                        d.room_number
                                                                    }
                                                                >
                                                                    {
                                                                        d.room_number
                                                                    }
                                                                </option>
                                                            ))}
                                                </select>
                                            </div>
                                            
                                            {/* Check In Status */}
                                            <div>
                                                <label
                                                    htmlFor=""
                                                    className="font-medium"
                                                >
                                                    Check-in Status
                                                </label>
                                                <div className="flex gap-4 px-1 mt-1">
                                                    <div className="flex items-center gap-1.5 w-1/2">
                                                        <input
                                                            type="checkbox"
                                                            value="preCheckin"
                                                            name="preCheckin"
                                                            checked={
                                                                filters.preCheckin
                                                            }
                                                            onChange={
                                                                handleFilterChange
                                                            }
                                                            id="preCheckin"
                                                        />
                                                        <label htmlFor="preCheckin">
                                                            Pre Check-in
                                                        </label>
                                                    </div>
                                                    <div className="flex items-center gap-1.5 w-1/2">
                                                        <input
                                                            type="checkbox"
                                                            value="postCheckin"
                                                            name="postCheckin"
                                                            checked={
                                                                filters.postCheckin
                                                            }
                                                            onChange={
                                                                handleFilterChange
                                                            }
                                                            id="postCheckin"
                                                        />
                                                        <label htmlFor="postCheckin">
                                                            Post Check-in
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Staff  */}
                                            <div>
                                                <label htmlFor="">Staff</label>
                                                <select
                                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                                        filters.staff === ""
                                                            ? "text-gray-500"
                                                            : "text-black"
                                                    }`}
                                                    name="staff"
                                                    value={filters.staff}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                >
                                                    <option value="">
                                                        Choose Staff
                                                    </option>

                                                    {/* Filter out items without staff_member_name */}

                                                    {data &&
                                                        data
                                                            .filter(
                                                                (d) =>
                                                                    d.staff_member_name,
                                                            )
                                                            .reduce(
                                                                (unique, d) => {
                                                                    if (
                                                                        !unique.some(
                                                                            (
                                                                                item,
                                                                            ) =>
                                                                                item.staff_member_name ===
                                                                                d.staff_member_name,
                                                                        )
                                                                    ) {
                                                                        unique.push(
                                                                            d,
                                                                        ); // Add the item only if the name is unique
                                                                    }
                                                                    // Reduce to an array of unique items
                                                                    return unique;
                                                                },
                                                                [],
                                                            )
                                                            .map((d, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={
                                                                        d.staff_member_name
                                                                    }
                                                                >
                                                                    {
                                                                        d.staff_member_name
                                                                    }
                                                                </option>
                                                            ))}
                                                </select>
                                            </div>

                                            {/* Request Type */}
                                            <div>
                                                <div className="">Select requests</div>
                                                <div className="flex flex-wrap gap-2 mt-2 h-[130px] overflow-y-scroll">
                                                    {requestOptions.map((request, index) => {
                                                    const isSelected = filters.requests.includes(request);
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`px-3 py-1 rounded-lg text-[11px] cursor-pointer 
                                                                ${isSelected ? "bg-[#ff7378] text-white" : "bg-gray-200 text-black"}`}
                                                            onClick={() => toggleRequest(request)}
                                                            >
                                                            {request}
                                                        </div>
                                                    );
                                                    })}
                                                </div>
                                            </div>


                                        </div>

                                        {/* Buttons Data */}
                                        <div className="bg-[#F2F7FF] px-3 py-2 flex items-center justify-between">
                                            <button
                                                className="text-[#ff7378] border-[1.5px] rounded-md px-2 py-1"
                                                onClick={resetFilters}
                                            >
                                                Reset
                                            </button>
                                            <button
                                                className="bg-[#ff7378] px-3 py-1 rounded-md"
                                                onClick={applyFilter}
                                            >
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Header and filter components remain unchanged */}
                    <div className="w-full flex gap-3">
                        {statusOrder.map((status) => {
                            if (!groupedRequests[status]) return null;
                            const { title, bgColor, headerBg, statusBg } =
                                getStatusDetails(status);
                            return (
                                <div
                                    key={status}
                                    className={`${bgColor} w-1/4 rounded-md shadow-md overflow-hidden`}
                                >
                                    <div className={`${headerBg} p-2`}>
                                        <h2
                                            className={`${statusBg} text-white rounded-full px-2 py-1 text-xs w-fit`}
                                        >
                                            {title}
                                        </h2>
                                    </div>
                                    <div className="p-2 flex flex-col gap-2 overflow-scroll h-[70vh]">
                                        <style jsx="true">{`
                                            div::-webkit-scrollbar {
                                                display: none; /* For Chrome, Safari, and Opera */
                                            }
                                        `}</style>
                                        {[...groupedRequests[status]]
                                            .sort((a, b) => {
                                                const rankDiff =
                                                    (escalationRank[
                                                        b.escalation_level
                                                    ] || 0) -
                                                    (escalationRank[
                                                        a.escalation_level
                                                    ] || 0);
                                                if (rankDiff !== 0)
                                                    return rankDiff;
                                                return (
                                                    new Date(b.updated_at) -
                                                    new Date(a.updated_at)
                                                );
                                            }) // Escalated first, then updated_at
                                            .map((request, index) => (
                                                <RequestCard
                                                    key={index}
                                                    request={request}
                                                />
                                            ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Request;
